import { render, staticRenderFns } from "./TermosDeUso.vue?vue&type=template&id=3ff27522&scoped=true"
import script from "./TermosDeUso.vue?vue&type=script&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.css?vue&type=style&index=0&id=3ff27522&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff27522",
  null
  
)

export default component.exports